import React from 'react';
import './ProfileSectionPreview.css';

export function AdminFormFieldRow({
  label,
  value,
  editing,
  changed,
  compareValue,
  children,
}: {
  label: string;
  value?: string;
  editing?: boolean;
  changed?: boolean;
  compareValue?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="profile-section-preview__field">
      <div className="profile-section-preview__field-label">{label}</div>
      <div className="profile-section-preview__field-value">
        {editing ? (
          children
        ) : (
          <span style={changed ? { color: '#c62828', fontWeight: 600 } : undefined}>
            {value?.trim() || '—'}
            {changed && compareValue != null && (
              <span className="profile-section-preview__muted" style={{ display: 'block', fontSize: 11 }}>
                比較: {compareValue.trim() || '—'}
              </span>
            )}
          </span>
        )}
      </div>
    </div>
  );
}
